import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Link } from "react-router-dom";

import BackgroundLogin from '../../assets/images/background-login.png';
import BackgroundLoginMobile from '../../assets/images/background-login-mobile.png';

type ParamsStyle = {
   theme?: Theme;
}

export const Container = styled.div(
   ({ theme }: ParamsStyle) => `
   width: 100%;
   height: 100vh;
   display: flex;
   flex-direction: column;
   
   @media(min-width: ${theme?.breakpoints.values.md}px) {
      flex-direction: row;
   }
`);

export const ContentBackground = styled.div(
   ({ theme }: ParamsStyle) => `
   width: 100%;
   height: 50%;
   display: flex;
   position: relative;
   padding: 1.81rem 0;
   align-items: center;
   flex-direction: column;
   justify-content: flex-end;
   background-image: linear-gradient(0deg, rgba(12, 28, 51, .5), rgba(12, 28, 51, .5)),
   url('${BackgroundLoginMobile}');

   background-size: cover;
   background-repeat: no-repeat;

   svg {
      position: absolute;
      margin-left: auto;
      margin-right: auto;
      left: 0;
      right: 0;
      height: 100%;
      text-align: center;
      max-width: 7.31rem;
   }

   @media(min-width: ${theme?.breakpoints.values.md}px) {
      width: 40%;
      height: 100%;
      padding: 3.375rem 0 2rem;
      border-right: 7.75px solid #97C93D;
      justify-content: space-between;

      background-image: linear-gradient(0deg, rgba(12, 28, 51, .60), rgba(12, 28, 51, .60)),
      url('${BackgroundLogin}');

      svg {
         height: auto;
         position: relative;
         max-width: 9.56rem;
      }
   }
`);

export const LinkButton = styled.a(
   ({ theme }: ParamsStyle) => `
   width: 11.75rem;
   height: 2.81rem;
   color: #a0cd4c;
   display: flex;
   border-radius: 5px;
   align-items: center;
   justify-content: center;
   background: rgba(255, 238, 238, 0.45);
   
   font-weight: 700;
   line-height: 14px;
   font-size: .875rem;

   &.no-login {
      width: 100%;
      height: 2.5rem;
      color: white;
      margin-top: 0;
      font-size: 1rem;
      font-weight: 400;
      border-radius: 5px;
      background: ${theme?.palette.primary.main};

      svg {
         margin-right: .5rem;
         margin-bottom: 4px;

         path {
            fill: ${theme?.palette.secondary.main};
         }
      }

      @media(min-width: ${theme?.breakpoints.values.md}px) {
         margin-top: 2rem;
         height: 2.81rem;
      }
   }
`);

export const LinkCharges = styled(Link)(
   ({ theme }: ParamsStyle) => `
      width: 100%;
      height: 2.5rem;
      color: white;
      margin-top: 0;
      display: flex;
      font-size: 1rem;
      font-weight: 400;
      padding-top: 4px;
      line-height: 14px;
      border-radius: 5px;
      align-items: center;
      justify-content: center;
      background: ${theme?.palette.primary.main};

      svg {
         margin-right: .5rem;
         margin-bottom: 4px;
         
         path {
            fill: ${theme?.palette.secondary.main};
         }
      }

      @media(min-width: ${theme?.breakpoints.values.md}px) {
         margin-top: 1rem;
         height: 2.3rem;
      }

      @media(min-width: ${theme?.breakpoints.values.lg}px) {
         margin-top: 2rem;
         height: 2.81rem;
      }
`);

export const ContentLogin = styled.div(
   ({ theme }: ParamsStyle) => `
   display: flex;
   width: 100%;
   height: 50%;
   
   align-items: center;
   flex-direction: column;
   justify-content: flex-start;
   padding: 0 1.25rem;

   #ic-background {
      position: absolute;
      right: 0;
      bottom: 0;
      max-width: 8rem;
      max-height: 11rem;
   }

   @media(min-width: ${theme?.breakpoints.values.md}px) {
      width: 60%;
      height: 100%;
      justify-content: center;

      #ic-background {
         max-width: 100%;
         max-height: 100%;
      }
   }
`);

export const Form = styled.form(
   ({ theme }: ParamsStyle) => `
   width: 100%;
   display: flex;
   align-items: center;
   border-radius: 10px;
   position: relative;
   flex-direction: column;
   justify-content: center;

   padding: 2rem 0 1.5rem;

   button {
      width: 100%;
      margin-top: .5rem;
   }

   @media(min-width: ${theme?.breakpoints.values.md}px) {
      width: 385px;
      padding: 1.875rem 1.875rem 1.5rem;
      border: 1.5px solid rgba(12, 28, 51, 0.5);

      button {
         width: 100%;
         margin-top: .3rem;
      }
   }

   @media(min-width: ${theme?.breakpoints.values.lg}px) {
      width: 385px;
      padding: 2rem 1.875rem 1.5rem;
      border: 1.5px solid rgba(12, 28, 51, 0.5);

      button {
         width: 100%;
         margin-top: .5rem;
      }
   }
`);
